const windowHost = window.location.host.replace("admin.", "");
const envHost = (import.meta.env.MODE === "development" ? import.meta.env.VITE_HOST_DEV || windowHost : windowHost) as string;

export function useWindowLocationHost() {
  const companies = ["sm", "calmap", "santamaria"] as const;
  const matchedCompany = companies.find((company) => windowHost.startsWith(`dev${company}`));

  return {
    windowLocationHost: matchedCompany ? `dev${matchedCompany}.nextcargo.app` : envHost
  };
}

export function useWindowIsShippingCompanyPage() {
  return {
    isShippingCompanyPage: envHost.includes("transportadoras")
  };
}
